import { Indicator } from 'mint-ui';
import env from '@/utils/env';
import appConst from '@/const/app.const';
import Native from '@/utils/nativeProxy';
import alipay from '@/utils/platformUtils/alipay';
import wechat from '@/utils/platformUtils/wechat';
import paramUtil from '@/utils/param';
import authStore from '@/store/auth';
import { getMPPort } from './port';
// import galileo from '@/utils/galileo';
// import abConst from '@/const/ab.const';

/**
 * set document title when router change
 * @param {String} title title name
 */
export function setTitle(title) {
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  iframe.setAttribute('src', '/favicon.png');
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}

/**
 * 直接通过小程序原生的setNavigationBar修改webview title(避免出现iframe hack的兼容性问题)
 * @param {String} title 标题名称
 */
export function setTitleMP(title) {
  // 支付宝小程序
  if (env.isAlipayClient) {
    return alipay.mpPostMessage({
      command: 'setTitle',
      callbackId: `setTitle${(new Date()).getTime()}`,
      dataArray: [title],
    });
  }
  // fallback到iframe hack
  return setTitle(title);
}

export const BusinessTypeEnum = {
  UNKNOW: 0,
  BIKE: 1,
  ELEBIKE: 2,
  RENT: 4,
  TAXI: 5,
  FREERIDE: 6,
  PLATFROM: 7,
};

export const BizList = {
  HITCH: 201,
};

// 跳转到车主详情
export function goDriverDetail(query = {}) {
  const url = paramUtil.add(`${appConst.HITCH_API}#/v2/driver-detail`, {
    ...query,
    bizScene: BizList.HITCH,
  });
  const { IS_HITCH_INDEP, IS_PH } = getMPPort();
  const isHitchPassengerMP = IS_HITCH_INDEP || IS_PH;
  if (isHitchPassengerMP) {
    Native.openHitchPassengerMpWebview(url);
    return;
  }

  if (env.isEasyBikeApp || env.isHitchIndepApp) {
    Native.openHitchWebview({ url });
  } else {
    window.location.href = url;
  }
}

// 新版客服中心(h5)
// type: BusinessTypeEnum,
// hitchType 1 乘客 2 车主
// 以下三个字段可不传
// driverOrderId,
// passengerOrderId,
// planStartTime
export function toCustomerService({
  type,
  hitchType,
  driverOrderId,
  passengerOrderId,
  planStartTime,
  path,
  token,
  mobile,
  userGuid,
  ticket,
  needLogin,
  needOpenHitchWebview = false,
}) {
  let url = path ? `${appConst.CS_API_NEW}#${path}` : appConst.CS_WEB_NEW;
  // eslint-disable-next-line no-console
  console.info('customer service url', url);
  // let bizType = 0;
  // try {
  //   const { versionArgs } = await galileo.getAbSingleTestResult({
  //     experimentId: abConst.NEW_CS_URL,
  //     defaultVersionId: '202110212209075953',
  //   }).then( data => {console.log(data)});
  //   console.error('version args', versionArgs);
  //   if (versionArgs) {
  //     url = path ? `${appConst.CS_API_NEW}#${path}` : appConst.CS_WEB_NEW;
  //     bizType = hitchType === 1 ? 7 : 6;
  //   } else {
  //     url = path ? `${appConst.CS_API}#${path}` : appConst.CS_WEB;
  //   }
  // } catch (e) {
  //   console.error('get new url for customer service failed', e);
  //   // url = path ? `${appConst.CS_API}#${path}` : appConst.CS_WEB;
  // }
  url = paramUtil.add(url, {
    type,
    hitchType,
    driverOrderId,
    passengerOrderId,
    planStartTime,
    h5Login: 1,
    openType: 'webview',
  });
  if (needLogin) {
    url = paramUtil.add(url, {
      token,
      mobile,
      userGuid,
      ticket,
    });
  }
  // eslint-disable-next-line no-console
  console.error(' token,mobile,userGuid, ticket,: ', token,
    mobile,
    userGuid,
    ticket);
  const { IS_HITCH_INDEP, IS_PH } = getMPPort();
  const isHitchPassengerMP = IS_HITCH_INDEP || IS_PH;
  // eslint-disable-next-line no-console
  if (needOpenHitchWebview && (env.isEasyBikeApp || env.isHitchIndepApp)) {
    Native.openHitchWebview({ url });
  } else if (isHitchPassengerMP) {
    Native.openHitchPassengerMpWebview(url);
  } else {
    window.location.href = url;
  }
}

/**
 * cache return for function, ensure that the function is executed only once
 * @param {Function} func
 */

export function onceWrapper(func) {
  let isExecuted = false;
  let promiseObj = null;

  return (...arg) => {
    if (isExecuted) return promiseObj;
    isExecuted = true;
    promiseObj = func(...arg);
    return promiseObj;
  };
}

/**
 * 时间戳格式化.
 * @param  {number} time 时间戳 .
 * @param  {string} formatStr 格式 .
 * @param  {boolean} ms 时间戳是否是秒为单位, 10位true, 13位false .
 * @return {string} 格式化后的字符串.
 */
export function format(time, formatStr, ms) {
  const t = new Date(ms ? time * 1000 : +time);
  const tf = function addZero(i) {
    return (i < 10 ? '0' : '') + i;
  };
  const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  return formatStr.replace(/yyyy|MM|dd|HH|mm|ss|ww/g, (a) => {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear());
      case 'MM':
        return tf(t.getMonth() + 1);
      case 'mm':
        return tf(t.getMinutes());
      case 'dd':
        return tf(t.getDate());
      case 'HH':
        return tf(t.getHours());
      case 'ss':
        return tf(t.getSeconds());
      case 'ww':
        return week[t.getDay()];
      default:
        return '';
    }
  });
}

/**
 * 函数防抖.
 * @param  {function} fn 要执行的函数.
 * @param  {number} delay 防抖的延时单位毫秒.
 * @return {function} 防抖后的函数.
 */
export function debounce(fn, delay) {
  let timer = null;
  return function func(...rest) {
    const context = this;
    const args = rest;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * 数组分组.
 * @param {Array} array 要分组的数组.
 * @param {Function} groupByFun 分组函数.
 * @param {Object} {
 *  itemFormatter,
 *  sortFun,
 *  groupNameKey = 'name',
 *  groupValueKey items',
 * } itemFormatter:数组项格式化函数, sortFun:分组排序函数, groupNameKey:分组名称key值, groupValueKey:分组数据key值.
 */
export function groupBy(array, groupByFun, {
  itemFormatter,
  sortFun,
  groupNameKey = 'name',
  groupValueKey = 'items',
}) {
  if (!array || !Array.isArray(array)) return [];
  if (!groupByFun || (typeof groupByFun !== 'function')) return array;
  const groups = {};
  array.forEach((o) => {
    const group = groupByFun(o);
    groups[group] = groups[group] || [];
    groups[group].push(itemFormatter ? itemFormatter(o) : o);
  });
  const results = Object.keys(groups).map((group) => {
    const r = {};
    r[groupNameKey] = group;
    r[groupValueKey] = groups[group];
    return r;
  });
  if (sortFun && (typeof sortFun === 'function')) {
    return results.sort(sortFun);
  }
  return results;
}

/**
 * * 拼接查询参数
 * @param {Object} params 查询参数对象
 */
export function transformQueryString(params) {
  const _params = {
    platform: env.platform.app,
    ...params,
  };
  delete _params.token;
  delete _params.phone;
  return `?${Object.keys(_params).map((key) => `${key}=${_params[key]}`).join('&')}`;
}

/**
 * 关掉webview
 */
export function quit() {
  if (env.isAliMP) {
    alipay.mpNavigateBackByDelta();
  } else if (env.isEasyBikeApp || env.isHitchIndepApp) {
    Native.closeWebView();
  } else if (env.isWeixinMp) {
    wechat.navigateBack();
  } else if (env.isChannelApp) {
    Native.closeWebView();
  } else {
    window.history.go(-1);
  }
}

export class Loading {
  static showInitialLoading = false

  static _loadingTimeOut = null;

  /**
   * 显示Loading提示
   * 如果设置了延时等待时间，那么会添加一个定时任务，可能在任务还没执行的时候被清除掉
   * @param {string} [content=加载中] - 提示内容
   * @param {boolean} [noDelay=1000] - 延时等待显示的时间
   * @return {Promise}
   */
  static showLoading(content = '加载中', noDelay) {
    if (this.showInitialLoading === true) {
      return Promise.resolve();
    }
    if (this._loadingTimeOut) {
      clearTimeout(this._loadingTimeOut);
    }
    return new Promise(() => {
      this._loadingTimeOut = setTimeout(() => {
        this._loadingTimeOut = null;
        Indicator.open(content);
      }, noDelay ? 0 : 1000);
    });
  }

  /**
   * 隐藏Loading提示, 如果存在loading的定时任务会清除掉
   * @return {Promise}
   */
  static hideLoading() {
    if (this._loadingTimeOut) {
      clearTimeout(this._loadingTimeOut);
      this._loadingTimeOut = null;
    }
    Indicator.close();
    return Promise.resolve();
  }
}

/**
   * * 获取平台枚举
   * @returns {number} 1 app 2 支付宝 3 微信小程序 4 H5
   */
export function getPlatformEnum() {
  if (env.isEasyBikeApp || env.isHitchIndepApp) {
    return 1;
  } if (env.isAlipayClient) {
    return 2;
  } if (env.isWeixin) {
    return 3;
  }
  return 4;
}

/**
   * * 是否是端内
   * @returns {boolean}
   */
export function isInnerClient() {
  return env.isEasyBikeApp || env.isAliMP || env.isWeixinMp || env.isHitchIndepApp;
}

/**
   * * 是否登录
   * @returns {boolean}
   */
export async function isLogin() {
  if (isInnerClient()) {
    const { token } = await Native.getTokenAndKey();
    return !!token;
  }
  return !!authStore.token;
}
